export const LANDING_LINKS = [
  { id: 'what-is-pro', label: 'Vad är Booli Pro' },
  { id: 'services', label: 'Tjänster' },
  { id: 'pro-explained', label: 'Så fungerar det' },
  { id: 'benefits', label: 'Varför Booli Pro' },
  { id: 'hpi', label: 'SBAB Booli Housing Price Index (HPI)' },
  { id: 'testimonials', label: 'Testimonials' },
] as const;

export const LANDING_SECTION_IDS: readonly string[] = [...LANDING_LINKS.map(({ id }) => id), 'demo'];
